// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"rq-z","breadcrumbForward":"sq-z","breadcrumbBack":"tq-z","selected":"uq-z"};